// @ts-nocheck
import useProductDetailsZoomState from "@store/Framework/Common/Hooks/useProductDetailsZoomState";
import { useEffect, useRef } from "react";
import ImageZoom, { ZoomOptions } from "./imagezoom";
import debounce from "lodash/debounce";

export interface UseZoomOptions extends Omit<ZoomOptions, "scale"> {
    targetImageSize?: number;
    imageIndex?: number;
}
const useImageZoom = (options: UseZoomOptions, containerRef: React.RefObject<HTMLElement>, zoomContainerId: string) => {
    const imageZoom = useRef<ReturnType<typeof ImageZoom> | null>(null);
    const targetImageSize = options.targetImageSize || 5000;
    const [isZoomOpen, setIsZoomOpen] = useProductDetailsZoomState();
    const zoomedElement = document?.getElementById(zoomContainerId);
    const startingPosition = useRef<{ x: number; y: number } | null>(null);
    
    useEffect(() => {
        if (!containerRef.current) {
            return;
        }
        const handleMouseMove = debounce((event: MouseEvent) => {
            if (!isZoomOpen) {
                startingPosition.current = { x: event.clientX, y: event.clientY };
            }
        }, 100);
        containerRef.current.addEventListener("mousemove", handleMouseMove);
        return () => {
            containerRef.current?.removeEventListener("mousemove", handleMouseMove);
        };
    }, [containerRef, isZoomOpen]);

    useEffect(() => {
        if (!isZoomOpen) {
            if (imageZoom.current) {
                imageZoom.current.kill();
                imageZoom.current = null;
            }
            return;
        }
        if (zoomedElement && containerRef.current) {
            const scale = targetImageSize / containerRef.current.clientWidth;

            imageZoom.current = ImageZoom(
                containerRef.current,
                {
                    ...options,
                    zoomContainer: zoomedElement,
                    scale,
                },
                startingPosition.current ?? undefined,
            );
        } else if (containerRef.current) {
            imageZoom.current = ImageZoom(containerRef.current, options);
        }

        return () => {
            if (imageZoom.current) {
                imageZoom.current.kill();
                imageZoom.current = null;
            }
        };
    }, [options, containerRef, zoomContainerId, isZoomOpen, zoomedElement]);
    return { imageZoom, isZoomOpen, setIsZoomOpen };
};

export default useImageZoom;
